'use strict';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

class BlockParagraphLong {

	constructor($target) {
		
		//Private properties
		$target;

		function init(){
		
		}


		init();



	}

}

export default BlockParagraphLong;